import Swiper from "lib/swiper";
window.app.directive("swiper", [
  "$timeout",
  function($timeout) {
    return {
      restrict: "A",
      scope: false,
      priority: 1,
      link: function(scope, element, attrs) {
        // eslint-disable-next-line no-new
        new Swiper(/*element*/ ".newsfeed-swiper", {
          speed: 400,
          // spaceBetween: 40,
          observer: true,
          centeredSlides: true,
          slidesPerView: 1,
          // navigation: {
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev',
          // },
          navigation: true,
          nextButton: ".swiper-button-next",
          prevButton: ".swiper-button-prev"
        });
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/directives/swiper.js